var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCx = function SvgIconCx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M20.485 20.486c-4.686 4.686-12.284 4.686-16.97 0-4.687-4.687-4.687-12.285 0-16.97.369.368 9.592 7.378 9.592 7.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.515 3.514c4.686-4.686 12.284-4.686 16.97 0 4.687 4.686 4.687 12.285 0 16.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 15.131a3.13 3.13 0 1 0 0-6.26 3.13 3.13 0 0 0 0 6.26"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.469 17.218.33.688.743-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.743.172zM2.314 11.477l.33.689.743-.172-.333.687.598.474-.744.168.002.763-.596-.478-.595.478.002-.764-.744-.167.598-.474-.333-.687.743.172zM4.469 6.782l.329.689.744-.172-.333.686.598.475-.745.167.002.764-.595-.478-.596.478.002-.764-.744-.167.598-.475-.333-.686.743.172zM7.145 10.435l.329.688.743-.172-.333.687.598.475-.744.167.002.764-.596-.478-.595.477.002-.763-.744-.167.598-.475-.333-.687.743.172zM5.23 13.565l.26.797h.838l-.678.492.259.798-.678-.493-.678.493.259-.797-.678-.493h.838z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 14.087h1.043s.453-.8 0-1.565l1.044-1.043-.522-1.044h-.521s-.261.783-1.305.783c-1.043 0-1.304-.783-1.304-.783h-.522l.522 1.043-.522 1.044.522.522S10.956 12 12 12.522c0 0 .443.652 0 1.565"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M19.789 6.572q.037-.192.037-.395c0-.928-.605-1.715-1.443-1.986a3.9 3.9 0 0 1 .352 2.338 2.142 2.142 0 0 0-3.003-.655 4 4 0 0 1 1.64.78c.39.31.704.73.945 1.134l-3.186.997c3.13.522 5.739-1.565 5.739-1.565-.29-.578-.738-.675-1.081-.648"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCx;